function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#7B8B99",
  fillRule: "evenodd",
  d: "M8 16A8 8 0 118 0a8 8 0 010 16zm.323-10.853a1.172 1.172 0 001.25-1.072 1.172 1.172 0 00-1.25-1.072 1.172 1.172 0 00-1.25 1.072c.053.64.61 1.117 1.25 1.072zm.508 2.417a1.074 1.074 0 00-1.044-1.345H6.719a.357.357 0 00-.357.357v.116c0 .146.088.277.224.332.35.14.54.52.444.884l-.995 3.756a1.074 1.074 0 001.044 1.344h1.068c.197 0 .357-.16.357-.357v-.115a.357.357 0 00-.224-.332.747.747 0 01-.444-.885l.995-3.755z"
});

var SvgIconInfoGray = function SvgIconInfoGray(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref);
};

export default SvgIconInfoGray;